module.exports = __webpack_public_path__ + "static/media/logo.11cb1ce2.PNG";